import { computed, ref } from "vue";

const infogramKlaroTitle: string = "Infogram";
const infogramScriptId: string = "infogram-async";
const klaroManager = ref(window.klaro?.getManager());
const klaroWatcher = {
  update: (_manager: any, name: string, data: any) => {
    if (name !== "consents") return;

    if (!data[infogramKlaroTitle]) destroyInfogramScript();
    else loadInfogram();
  },
};

const loadInfogram = async (): Promise<void> => {
  const title = "InfogramEmbeds";
  const element = document.getElementsByTagName("script")[0];

  if (!infogramConsent) return;

  if (window[title] && window[title].initialized) {
    window[title]?.process();
  } else if (!document.getElementById(infogramScriptId)) {
    const newScript = document.createElement("script");
    newScript.async = true;
    newScript.id = infogramScriptId;
    newScript.src = "https://e.infogram.com/js/dist/embed-loader-min.js";
    element?.parentNode?.insertBefore(newScript, element);
  }
};

const destroyInfogramScript = () => {
  const element = document.getElementById(infogramScriptId);
  if (!element) return;

  element.remove();
};

const infogramConsent = computed((): boolean => klaroManager.value?.getConsent(infogramKlaroTitle));

const infogramWatchConsent = (): void => {
  klaroManager.value?.watch(klaroWatcher);
};

const infogramUnwatchConsent = (): void => {
  klaroManager.value?.unwatch(klaroWatcher);
};

export const InfogramComposable = {
  loadInfogram,
  infogramWatchConsent,
  infogramUnwatchConsent,
};
